import { Loader } from 'google-maps';

// Ask Eugen T for changing the keys if necessary. 
let key = 'AIzaSyBYc3ssywulF7J8-oPmH2iC-Do9051i4oA';
if (document.querySelector('body').classList.contains('wordminds-site')) {
  key = 'AIzaSyCnzb0bfR0kr2o79njKEgxMjtFA1vEqn6s';
}

const loader = new Loader(key);

loader.load().then((google) => {
  // headquoters map
  (() => {
    const element = document.querySelector('.js-map[data-id="1"]');
    if (!element) return false;

    const markerCenter = new google.maps.LatLng(Number(element.dataset.latitude), Number(element.dataset.longitude));
    const options = {
      center: {
        lat: Number(element.dataset.latitude),
        lng: Number(element.dataset.longitude),
      },
      zoom: 16,
      panControl: false,
      zoomControl: true,
      mapTypeControl: false,
      scaleControl: false,
      streetViewControl: false,
      overviewMapControl: false,
      rotateControl: false,
    };
    const map = new google.maps.Map(element, options);

    // eslint-disable-next-line no-unused-vars
    const marker2 = new google.maps.Marker({
      position: markerCenter,
      map,
      optimized: false,
    });
  })();
  // division map
  (() => {
    const element = document.querySelector('.js-map[data-id="2"]');
    if (!element) return false;

    const markerCenter = new google.maps.LatLng(Number(element.dataset.latitude), Number(element.dataset.longitude));
    const options = {
      center: {
        lat: Number(element.dataset.latitude),
        lng: Number(element.dataset.longitude),
      },
      zoom: 16,
      panControl: false,
      zoomControl: true,
      mapTypeControl: false,
      scaleControl: false,
      streetViewControl: false,
      overviewMapControl: false,
      rotateControl: false,
    };
    const map = new google.maps.Map(element, options);

    // eslint-disable-next-line no-unused-vars
    const marker = new google.maps.Marker({
      position: markerCenter,
      map,
      optimized: false,
    });
  })();
});
